import ClusterScoreStatisticsItemModel from './score-statistics-item.model';

export default class ClusterScoreStatisticsModel {
    [date: string]: ClusterScoreStatisticsItemModel
}
